import { Tag as TagAntd } from "antd";
import styled, { css } from "styled-components";

interface IContainer {
  isContentScreen: boolean;
  isProductBundleScreen: boolean;
  isCourseLandingPageCard: boolean;
  isCourseLandingPageFooter: boolean;
  customButtonColor: string;
  themeBuyButtonsOption: string;
}

export const Container = styled.div<IContainer>`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  ${({ isCourseLandingPageFooter, isProductBundleScreen }) =>
    (isCourseLandingPageFooter || isProductBundleScreen) &&
    css`
      justify-content: center;
    `}

  .prices-plus-info {
    width: 100%;
    display: flex;
    flex-direction: column;

    & > h5 {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 8px;
    }

    span {
      color: #999;
      font-weight: 300;
    }

    .starting-at {
      font-size: 15.5px;
    }

    .outside-footer {
      font-weight: 400;
      margin-bottom: 2px;
    }

    ${({ isContentScreen }) =>
      isContentScreen &&
      css`
        .starting-at {
          color: #fff;
          text-align: center;
        }
      `}

    ${({ isCourseLandingPageFooter, isProductBundleScreen }) =>
      (isCourseLandingPageFooter || isProductBundleScreen) &&
      css`
        order: 2;
        width: fit-content;
      `}
  }

  .prices {
    width: 100%;
    display: flex;
    flex-direction: column;

    ${({ isProductBundleScreen }) =>
      !isProductBundleScreen &&
      css`
        margin-bottom: 8px;
      `}

    & > div {
      display: flex;
      align-items: center;
    }

    h5 {
      margin: 0;
      font-size: 25px;
    }

    .price {
      margin-right: 0.8rem;
      font-weight: bold;
      font-size: ${({ isCourseLandingPageFooter }) =>
        !isCourseLandingPageFooter && "1.75rem"};
      color: ${({ theme }) => theme.colors.textColor};
    }

    .in-cash {
      font-size: 1rem;
      font-weight: normal;
      color: ${({ theme }) => theme.colors.textColor};
    }

    .before-price {
      font-size: ${({ isCourseLandingPageFooter }) =>
        !isCourseLandingPageFooter && "1.25rem"};
    }

    .starting-at {
      margin: 0 0 8px;
    }

    ${({ isContentScreen }) =>
      isContentScreen &&
      css`
        justify-content: center;
      `}

    ${({ isProductBundleScreen }) =>
      isProductBundleScreen &&
      css`
        margin-bottom: 0;
        width: fit-content;
        flex-direction: column;

        .price {
          color: #fff;
        }

        @media screen and (max-width: 480px) {
          h5 {
            font-size: 20px;
          }
        }
      `}

    ${({ isCourseLandingPageFooter }) =>
      isCourseLandingPageFooter &&
      css`
        margin-bottom: 0;
        width: fit-content;
        flex-direction: column;

        h5 {
          font-size: 16px;
        }

        .price {
          margin-right: 0;
        }
      `}
  }

  .info-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-self: flex-start;

    .installments {
      font-size: 1rem;
      font-weight: normal;
      color: ${({ theme }) => theme.colors?.textColorInstallments};
    }

    ${({ isContentScreen }) =>
      isContentScreen &&
      css`
        justify-content: center;
      `}

    ${({ isProductBundleScreen }) =>
      isProductBundleScreen &&
      css`
        margin: 5px 0 0;

        .plan-interval {
          color: #999;
          font-size: 16px;
          text-transform: lowercase;
        }

        @media screen and (max-width: 480px) {
          .installments {
            margin-bottom: 5px;
          }
        }
      `}
  }

  button {
    width: 100%;
    margin: 0;

    ${({ isCourseLandingPageFooter }) =>
      isCourseLandingPageFooter &&
      css`
        flex: 1;
        margin-right: 10px;
      `}

    ${({ isProductBundleScreen }) =>
      isProductBundleScreen &&
      css`
        height: 50px;
        font-size: 16px;
        max-width: 200px;
        margin-right: 25px;
        transition: all ease-in-out 0.3s;
        box-shadow: 1px 15px 60px rgba(0, 0, 0, 0.16);

        &:hover {
          transform: scale(1.05);
          border: 2px solid ${({ theme }) => theme.colors.textColor} !important;
        }
      `}
  }

  .buy-btn {
    margin-top: 0 !important;
  }

  ${({ themeBuyButtonsOption }) =>
    themeBuyButtonsOption !== "automatic" &&
    css<IContainer>`
      .buy-btn {
        background-color: ${({ customButtonColor }) =>
          customButtonColor} !important;
        border-color: none;
      }
    `}

  .before-price-content {
    display: flex;
    align-items: center;

    width: fit-content;
    margin: 0 0 0.5rem 0;

    div {
      width: 100%;
    }

    @media (max-width: 315px) {
      flex-direction: column;

      .ant-col.ant-col-xs-14 {
        max-width: 100%;
      }
    }
  }

  .subs-closed {
    margin: 0;
    text-align: center;
  }
`;

export const Tag = styled(TagAntd)`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 1rem;
  margin: 0;

  height: 28px !important;

  font-size: 12px;
  font-weight: 600 !important;
  background: #5fb336;
  color: #ffffff !important;

  border: none !important;
  border-radius: 6px;
`;
